import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';

export class CoachSelectors {
  static state = (state: AppState) => state.coach;
  static loggedAsClient = createSelector(this.state, state => state.loggedAsClient);
}
